import paymentsRoutes from './payments'
import directDebitRoutes from './directDebit'
import directPaymentsRoutes from './directPayments'

export default [
  ...paymentsRoutes,
  ...directDebitRoutes,
  ...directPaymentsRoutes
]



// WEBPACK FOOTER //
// ./src/routes/services/index.js